import React from "react";
import { Key } from "react";
import { ClientSelectContainer } from "../../client-select";
import { FilterDropdownProps } from "antd/lib/table/interface";

export type ClientFilterProps = {
  setSelectedKeys: (selectedKeys: Key[]) => void;
  selectedKeys: Key[];
  confirm: () => void;
  clearFilters?: () => void;
};

export const filterClient = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}: ClientFilterProps) => (
  <ClientSelectContainer
    selectedFilterValues={selectedKeys.map(k => Number(k))}
    onApplyFilter={(values: number[]) => {
      setSelectedKeys(values);
      confirm();
    }}
    onClearFilter={() => {
      clearFilters?.();
      confirm();
    }}
  />
);

export const createClientFilterWithPreselection = (preselectedClientIds: number[]) => {
  return ({ setSelectedKeys, confirm, clearFilters }: FilterDropdownProps) => (
    <ClientSelectContainer
      preselectedClientIds={preselectedClientIds}
      onApplyFilter={(values: number[]) => {
        setSelectedKeys(values);
        confirm();
      }}
      onClearFilter={() => {
        clearFilters?.();
        confirm();
      }}
    />
  );
};
